  export const environment = {
  envName: 'stage',
  production: false,
  imagePrefix: '',
  apiUrl: 'https://api-dot-datalive-auditapp-staging.appspot.com',
  ssoAuthUrl: 'https://fcr.datalive-staging.com/oauth2/', // Local
  authRedirectLoginUrl: 'https://auth.datalive-staging.com/',
  appReference: 'AUDIT',
  developmentAccessToken: null
};
